module.exports = __webpack_public_path__ + "static/jim-00ddd186735e5f3412ed3fb3e5d124ae.jpg";